export default __webpack_public_path__ + "static/media/last-icon.4d6cf059.svg";